module.exports = __webpack_public_path__ + "img/ill_pakket_full_green.1f8917ea.svg";